/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';
import * as color from '@constant/color';
import * as size from '@constant/size';
import ImageBlock from '@component/common/block/image-block';
import { useNavigate } from 'react-router-dom';
import otterLandingPageImg from '@asset/image/otter-landing-page-1.webp';
import TextBlock from 'component/common/block/text-block';
import Gap from '@component/common/gap';
import { getInitialServicePath } from '@constant/common/route-path';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

const BUTTON_DESIGN = {
  box: {
    width: '100px',
    height: '40px',
    backgroundColor: color.BLACK_1,
    event: { cursor: 'pointer' },
  },
  text: {
    size: 'medium',
    color: color.WHITE_1,
  },
} as const;

const ErrorPage = ({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) => {
  const navigate = useNavigate();
  const handleClickHome = () => {
    resetErrorBoundary();
    navigate(getInitialServicePath());
  };
  const handleClickReload = () => resetErrorBoundary();

  return (
    <Wrapper>
      <ImageBlock src={otterLandingPageImg} alt='otter' design={{ image: { height: '300px' } }} />
      <Gap height={size.MARGIN_2} />
      <TextBlock
        text={'Error occurs as below 😢'}
        design={{
          text: {
            size: 'large',
            bold: true,
          },
        }}
      />
      <Gap height={size.MARGIN_1} />
      <TextBlock text={error.message} design={{ text: { size: 'medium' } }} />
      <Gap height={size.MARGIN_5} />
      <ButtonContainer>
        <TextBlock text='Home' design={BUTTON_DESIGN} click={{ handler: handleClickHome }} />
        <TextBlock text='Reload' design={BUTTON_DESIGN} click={{ handler: handleClickReload }} />
      </ButtonContainer>
    </Wrapper>
  );
};

export default ErrorPage;
